import { lazy } from 'react';

const StudentProgramsDetailsDrawer = lazy(
  () =>
    import(
      'modules/CTEProgramsDashboard/K12Admin/modals/StudentProgramsDetailsDrawer/StudentProgramsDetailsDrawerContainer'
    ),
);

export default {
  STUDENT_PROGRAMS_DETAILS_DRAWER: StudentProgramsDetailsDrawer,
};
